import { defineMessages } from "react-intl";

export const broadcastOneToOneMessages = defineMessages({
  oneToOneStream: {
    id: "broadcast.one.to.one.stream",
    defaultMessage: "1:1 Stream",
  },
});
